import { connect } from 'react-redux';
import React from 'react';
import { ColorPicker } from 'antd';
import { KBButton } from 'components';
import { reduxForm } from 'redux-form';
import { withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';

const InlineColorPicker = ColorPicker._InternalPanelDoNotUseOrYouWillBeFired;
const COLOR_PRESETS = [
  {
    label: '常用颜色',
    colors: [
      '#D0021B',
      '#F5A623',
      '#F8E71C',
      '#8B572A',
      '#7ED321',
      '#417505',
      '#BD10E0',
      '#9013FE',
      '#4A90E2',
      '#50E3C2',
      '#B8E986',
      '#000000',
      '#4A4A4A',
      '#9B9B9B',
      '#FFFFFF'
    ]
  }
];

var VisitWelcomeSetColor = class extends React.Component {constructor(props) {super(props);this.save = this.save.bind(this);this.handleColorChange = this.handleColorChange.bind(this);}save(
  model) {
    const { saveAndUpdate } = this.props;
    return saveAndUpdate(model, 'accent_color');
  }handleColorChange(

  color) {
    const {
      fields: { accent_color } } =
    this.props;
    accent_color.onChange(color.toRgbString());
  }render()

  {
    const {
      fields: { accent_color },
      submitting,
      handleSubmit } =
    this.props;

    return (
      <form onSubmit={handleSubmit(this.save)}>
        <div className="visit-setting-block">
          <div className="title-container">
            <div className="title-and-des">
              <div className="title">主题颜色</div>
              <div className="des">选择欢迎页的主题颜色</div>
            </div>
            <KBButton
            className="certain-btn"
            style={
            accent_color.value ?
            { backgroundColor: `${accent_color.value}` } :
            {}}

            type="submit"
            submitting={submitting}>

              保存当前颜色
            </KBButton>
          </div>
          <div className="kb-row" style={{ textAlign: 'center' }}>
            <div className="visit-inline-color-picker">
              <InlineColorPicker
              value={accent_color.value || '#1677ff'}
              onChange={this.handleColorChange}
              format="rgb"
              presets={COLOR_PRESETS}
              disabledFormat />

            </div>
            <div style={{ fontSize: 12, color: '#666', marginTop: 20 }}>
              请选择合适主题色，避免与您上传的标志图形或LOGO颜色冲突。
            </div>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const { welcome } = props;
  let { accent_color } = welcome;

  return {
    initialValues: {
      accent_color: accent_color || '' } };


}

function mapDispatchToProps(dispatch) {
  return {};
}

const validate = values => {
  const errors = {};

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "accent_color"
];

const formConfig = {
  form: 'VisitWelcomeSetColorForm',
  validate: validate,
  enableReinitialize: true,
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('VisitWelcomeSetColorForm', LEGACY_FORM_FIELDS)(VisitWelcomeSetColor)));
